import { createContext } from "react";

/** True inside the AMP nav, whose rows sit 8px apart, closer than the classic nav's, and read a step darker. */
export const CompactNavContext = createContext(false);
